import React, {ChangeEvent, useRef} from 'react';

import './multipleRangeSlider.scss';
import classNames from 'classnames';
import useCalculatePercent from './hooks/useCalculatePercent';

interface MultipleRangeSliderProps {
  max: number;
  min: number;
  maxVal: number;
  minVal: number;
  setMaxVal: (max: number) => void;
  setMinVal: (max: number) => void;
}
const MultipleRangeSlider = ({
  max,
  min,
  maxVal,
  minVal,
  setMaxVal,
  setMinVal,
}: MultipleRangeSliderProps) => {
  const range = useRef<HTMLDivElement>(null);
  const minValRef = useRef<HTMLInputElement>(null);
  const maxValRef = useRef<HTMLInputElement>(null);
  useCalculatePercent(range, maxValRef, max, min, minVal);

  return (
    <div className="flex w-full items-center justify-center relative">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        ref={minValRef}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const value = Math.min(+event.target.value, maxVal - 1);
          setMinVal(value);
          event.target.value = value.toString();
        }}
        className={classNames('thumb thumb--zindex-3 bottom-[27px]', {
          'thumb--zindex-5': minVal > max - 100,
        })}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        ref={maxValRef}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const value = Math.max(+event.target.value, minVal + 1);
          setMaxVal(value);
          event.target.value = value.toString();
        }}
        className="thumb thumb--zindex-4 bottom-[27px]"
      />
      <div className="flex flex-col w-full items-center gap-4">
        <div className="flex w-full justify-between my-2">
          <div className="text-[18px] font-normal text-gray-5">
            از{minVal.toLocaleString()}
          </div>
          <div className="text-[18px] font-normal text-gray-5">
            تا{maxVal.toLocaleString()}
          </div>
        </div>
        <div className="slider h-[26px]">
          <div className="slider__track" />
          <div ref={range} className="slider__range" />
        </div>
      </div>
    </div>
  );
};

export default MultipleRangeSlider;
